interface Props {
  size?: number;
  height?: number;
}

export const UserIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24">
      <g id="profile-circle" transform="translate(-492 -252)">
        <path
          id="Vector"
          d="M3.4,6.55a.963.963,0,0,0-.24,0,3.28,3.28,0,1,1,.24,0Z"
          transform="translate(500.72 258.23)"
          fill="none"
          stroke="current"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M13.48,3.945a9.934,9.934,0,0,1-6.74,2.62A9.934,9.934,0,0,1,0,3.945a3.679,3.679,0,0,1,1.77-2.58,9.73
        ,9.73,0,0,1,9.94,0A3.679,3.679,0,0,1,13.48,3.945Z"
          transform="translate(497.26 267.435)"
          fill="none"
          stroke="current"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M20,10A10,10,0,1,1,10,0,10,10,0,0,1,20,10Z"
          transform="translate(494 254)"
          fill="none"
          stroke="current"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path id="Vector-4" data-name="Vector" d="M0,0H24V24H0Z" transform="translate(516 276) rotate(180)" fill="none" opacity="0" />
      </g>
    </svg>
  )
}

export const GroupIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24">
      <g id="element-4" transform="translate(-684 -252)">
        <path
          id="Vector"
          d="M8.5,8.9V2.1C8.5.6,7.86,0,6.27,0H2.23C.64,0,0,.6,0,2.1V8.9C0,10.4.64,11,2.23,11H6.27C7.86,11,8.5,10.4,8.5,8.9Z"
          transform="translate(697.5 254)"
          fill="none"
          stroke="current"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M8.5,3.9V2.1C8.5.6,7.86,0,6.27,0H2.23C.64,0,0,.6,0,2.1V3.9C0,5.4.64,6,2.23,6H6.27C7.86,6,
        8.5,5.4,8.5,3.9Z"
          transform="translate(697.5 268)"
          fill="none"
          stroke="current"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M8.5,2.1V8.9c0,1.5-.64,2.1-2.23,2.1H2.23C.64,11,0,10.4,0,8.9V2.1C0,.6.64,
        0,2.23,0H6.27C7.86,0,8.5.6,8.5,2.1Z"
          transform="translate(686 263)"
          fill="none"
          stroke="current"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-4"
          data-name="Vector"
          d="M8.5,2.1V3.9C8.5,5.4,7.86,6,6.27,6H2.23C.64,6,0,5.4,0,3.9V2.1C0,.6.64,0,2.23,
        0H6.27C7.86,0,8.5.6,8.5,2.1Z"
          transform="translate(686 254)"
          fill="none"
          stroke="current"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path id="Vector-5" data-name="Vector" d="M0,0H24V24H0Z" transform="translate(684 252)" fill="none" opacity="0" />
      </g>
    </svg>
  )
}

export const CommunityIcon = ({ size }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ? size : '24'} height={size ? size : '24'}
      viewBox="0 0 24 24"
    >
       <g data-name="vuesax/linear/people" transform="translate(-620 -252)">
        <g
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <g>
            <path d="M638 259.16a.605.605 0 00-.19 0 2.585 2.585 0 11.19 0z"></path>
            <path
              d="M636.97 266.44a5.635 5.635 0 003.94-.72 1.911 1.911 0 000-3.42 5.67 5.67 0 00-3.97-.71"
              data-name="Vector"
            ></path>
          </g>
          
          <g data-name="Group">
            <path
              d="M625.97 259.16a.605.605 0 01.19 0 2.585 2.585 0 10-.19 0z"
              data-name="Vector"
            ></path>
            <path
              d="M627.003 266.44a5.635 5.635 0 01-3.94-.72 1.911 1.911 0 010-3.42 5.67 5.67 0 013.967-.71"
              data-name="Vector"
            ></path>
          </g>
          <g data-name="Group">
            <path
              d="M632 266.63a.605.605 0 00-.19 0 2.585 2.585 0 11.19 0z"
              data-name="Vector"
            ></path>
            <path
              d="M629.09 269.78a1.911 1.911 0 000 3.42 5.677 5.677 0 005.82 0 1.911 1.911 0 000-3.42 5.723 5.723 0 00-5.82 0z"
              data-name="Vector"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const Security = ({ size }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ? size : '20'} height={size ? size : '20'}
      viewBox="0 0 20 20"
    >
      <path
        fillRule="evenodd"
        d="M11 11H9a1 1 0 100 2v1a1 1 0 102 0v-1a1 1 0 100-2z"
        clipRule="evenodd"
      ></path>
      <path
        d="M16 6.142V6A6 6 0 004 6v.142A3.99 3.99 0 001 10v6a4 4 0 004 4h10a4 4 0 004-4v-6a3.99 3.99 0 00-3-3.858zM10 2c2.206 0 4 1.794 4 4H6c0-2.206 1.794-4 4-4zm7 14c0 1.103-.897 2-2 2H5c-1.103 0-2-.897-2-2v-6c0-1.103.897-2 2-2h10c1.103 0 2 .897 2 2v6z"
      ></path>
    </svg>
  );
};

export const TimeIcon = ({ size }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ? size : '24'} height={size ? size : '24'}
      viewBox="0 0 24 24"
    >
      <g data-name="vuesax/linear/clock" transform="translate(-172 -188)">
        <g
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M194 200a10 10 0 11-10-10 10 10 0 0110 10z"></path>
          <path
            d="M187.71 203.18l-3.1-1.85a2.215 2.215 0 01-.98-1.72v-4.1"
            data-name="Vector"
          ></path>
        </g>
      </g>
    </svg>
  );
}
export const MoreIcon = ({ size }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ? size : '24'} height={size ? size : '24'}
      viewBox="0 0 24 24"
    >
      <g data-name="vuesax/linear/more" transform="translate(-556 -188)">
        <g >
          <path d="M561 198a2 2 0 102 2 2.006 2.006 0 00-2-2z" fill="current"></path>
          <path
            d="M575 198a2 2 0 102 2 2.006 2.006 0 00-2-2z"
            data-name="Vector"
            fill="current"
          ></path>
          <path
            d="M568 198a2 2 0 102 2 2.006 2.006 0 00-2-2z"
            data-name="Vector"
            fill="current"
          ></path>
        </g>
      </g>
    </svg>
  );
};